"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryOptionGroup = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const react_1 = tslib_1.__importDefault(require("react"));
const react_use_1 = require("react-use");
const data_1 = require("@grafana/data");
const runtime_1 = require("@grafana/runtime");
const ui_1 = require("@grafana/ui");
const QueryEditor_1 = require("../../QueryEditor");
function QueryOptionGroup({ title, children, collapsedInfo, queryStats }) {
    const [isOpen, toggleOpen] = (0, react_use_1.useToggle)(false);
    const styles = (0, ui_1.useStyles2)(getStyles);
    return (react_1.default.createElement("div", { className: styles.wrapper },
        react_1.default.createElement(ui_1.Collapse, { className: styles.collapse, collapsible: true, isOpen: isOpen, onToggle: toggleOpen, label: react_1.default.createElement(QueryEditor_1.EditorStack, { gap: 0 },
                react_1.default.createElement("h6", { className: styles.title }, title),
                !isOpen && (react_1.default.createElement("div", { className: styles.description }, collapsedInfo.map((x, i) => (react_1.default.createElement("span", { key: i }, x)))))) },
            react_1.default.createElement("div", { className: styles.body }, children)),
        queryStats && runtime_1.config.featureToggles.lokiQuerySplitting && (react_1.default.createElement(ui_1.Tooltip, { content: "Note: the query will be split into multiple parts and executed in sequence. Query limits will only apply each individual part." },
            react_1.default.createElement(ui_1.Icon, { tabIndex: 0, name: "info-circle", className: styles.tooltip, size: "sm" }))),
        queryStats && react_1.default.createElement("p", { className: styles.stats }, generateQueryStats(queryStats))));
}
exports.QueryOptionGroup = QueryOptionGroup;
const getStyles = (theme) => {
    return {
        collapse: (0, css_1.css)({
            backgroundColor: 'unset',
            border: 'unset',
            marginBottom: 0,
            ['> button']: {
                padding: theme.spacing(0, 1),
            },
        }),
        wrapper: (0, css_1.css)({
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
        }),
        title: (0, css_1.css)({
            flexGrow: 1,
            overflow: 'hidden',
            fontSize: theme.typography.bodySmall.fontSize,
            fontWeight: theme.typography.fontWeightMedium,
            margin: 0,
        }),
        description: (0, css_1.css)({
            color: theme.colors.text.secondary,
            fontSize: theme.typography.bodySmall.fontSize,
            fontWeight: theme.typography.bodySmall.fontWeight,
            paddingLeft: theme.spacing(2),
            gap: theme.spacing(2),
            display: 'flex',
        }),
        body: (0, css_1.css)({
            display: 'flex',
            gap: theme.spacing(2),
            flexWrap: 'wrap',
        }),
        stats: (0, css_1.css)({
            margin: '0px',
            color: theme.colors.text.secondary,
            fontSize: theme.typography.bodySmall.fontSize,
        }),
        tooltip: (0, css_1.css)({
            marginRight: theme.spacing(0.25),
        }),
    };
};
const generateQueryStats = (queryStats) => {
    if (queryStats.message) {
        return queryStats.message;
    }
    return `This query will process approximately ${convertUnits(queryStats)}.`;
};
const convertUnits = (queryStats) => {
    const { text, suffix } = (0, data_1.getValueFormat)('bytes')(queryStats.bytes, 1);
    return text + suffix;
};
//# sourceMappingURL=QueryOptionGroup.js.map